import { render, staticRenderFns } from "./UserAuthorisations.vue?vue&type=template&id=0c210e44&"
import script from "./UserAuthorisations.vue?vue&type=script&lang=ts&"
export * from "./UserAuthorisations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports